export enum StorageEnum {
  PREFIX = 'inside_hub_app.'
}

export enum StorageKeyEnum {
  TOKEN = 'token',
  EXIT_IMPERSONATE_RETURN_PARTNER_ID = 'exit-impersonate-return-partner-id'
}
